export default "__VITE_ASSET__Chk5DvhK__"